import {AbstractControl, ValidatorFn} from '@angular/forms';
import {LoaderService} from 'ngx-satoris';
import {FormField} from '../models/forms';

export function hasValue(value: unknown, type?: FormField['type']): boolean {
  if(type === 'date') {
    return value !== null && value !== undefined && value !== '';
  }
  return !!value;
}

export function notInArrayValidator(values: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value.toLowerCase();
    if(values.map(v => v.toLowerCase()).includes(value)) {
      return {'notInArray': {value: value}};
    }
    return null;
  };
}

export function warnIfInvalidName(firstName: string, lastName: string, loader: LoaderService): Promise<boolean> {
  const fn = firstName?.trim();
  const ln = lastName?.trim();
  const hasInvalidName =(fn !== undefined && fn.length < 2) || (ln !== undefined && ln.length < 2);
  if(!hasInvalidName) {
    return Promise.resolve(true);
  }
  return loader.loading(true, {type: 'warn', message: 'name.warn', btnLabel: 'global.confirm', buttonType: 'button', custom: {closeBtnLabel: 'global.cancel', disableClose: true}, shortcut: {show: false}}).then((confirmed: boolean) => confirmed === true);
}
